import React, { useState } from 'react';
import {
  Box,
  Heading,
  Input,
  Textarea,
  VStack, 
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
} from '@chakra-ui/react';
import { useModernToast } from '../components/ModernToast';

const ContactUsPage = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [errors, setErrors] = useState({ name: '', email: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useModernToast();

  const validate = () => {
    let valid = true;
    const errs = { name: '', email: '', message: '' };
    if (!form.name) { errs.name = 'Name is required'; valid = false; }
    if (!form.email) { errs.email = 'Email is required'; valid = false; }
    else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) { errs.email = 'Invalid email'; valid = false; }
    if (!form.message) { errs.message = 'Message is required'; valid = false; }
    setErrors(errs);
    return valid;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validate()) return;
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setForm({ name: '', email: '', message: '' });
      toast.success('Message sent!', 'We will get back to you soon.');
    }, 1200);
  };

  return (
    // <Box minH="100vh" minW="100vw" bg="black" color="white" display="flex" alignItems="center" justifyContent="center">
      <Box bg="#181818" p={10} borderRadius="lg" boxShadow="xl" maxW="400px" w="full" alignSelf="center" justifySelf="center">
        <Heading as="h1" size="lg" mb={6} fontFamily="Audiowide" textAlign="center">Contact Us</Heading>
        <form onSubmit={handleSubmit}>
          <VStack spacing={5} align="stretch">
            <FormControl isInvalid={!!errors.name} isRequired>
              <FormLabel>Name</FormLabel>
              <Input name="name" value={form.name} onChange={handleChange} bg="#222" color="white" borderColor="#333" _placeholder={{ color: '#aaa' }} />
              {errors.name && <FormErrorMessage>{errors.name}</FormErrorMessage>}
            </FormControl>
            <FormControl isInvalid={!!errors.email} isRequired>
              <FormLabel>Email</FormLabel>
              <Input name="email" value={form.email} onChange={handleChange} bg="#222" color="white" borderColor="#333" _placeholder={{ color: '#aaa' }} />
              {errors.email && <FormErrorMessage>{errors.email}</FormErrorMessage>}
            </FormControl>
            <FormControl isInvalid={!!errors.message} isRequired>
              <FormLabel>Message</FormLabel>
              <Textarea name="message" value={form.message} onChange={handleChange} bg="#222" color="white" borderColor="#333" _placeholder={{ color: '#aaa' }} rows={5} />
              {errors.message && <FormErrorMessage>{errors.message}</FormErrorMessage>}
            </FormControl>
            <Button type="submit" color="white" isLoading={isSubmitting} variant="dominus" _hover={{ bg: '#166c0f' }}>
              Send Message
            </Button>
          </VStack>
        </form>
      </Box>
    // </Box>
  );
};

export default ContactUsPage; 